export const FETCH_COUNTRIES_REQUEST = "FETCH_COUNTRIES_REQUEST";
export const CREATE_COUNTRY_REQUEST = "CREATE_COUNTRY_REQUEST";
export const UPDATE_COUNTRY_STATUS_REQUEST = "UPDATE_COUNTRY_STATUS_REQUEST";
export const UPDATE_COUNTRY_WEIGHT_REQUEST = "UPDATE_COUNTRY_WEIGHT_REQUEST";
export const UPDATE_COUNTRY_REQUEST = "UPDATE_COUNTRY_REQUEST";
